import React, { useState, useEffect } from 'react';
import axios from 'axios';

const AdminTransactions = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailTransaction, setDetailTransaction] = useState(null);
  const [detailRoutes, setDetailRoutes] = useState([]);
  const [loadingRoutes, setLoadingRoutes] = useState(false);

  useEffect(() => {
    fetchTransactions();
  }, []);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const res = await axios.get('/api/admin/transactions');
      setTransactions(res.data);
    } catch (error) {
      console.error('Error fetching transactions:', error);
      alert('Error al cargar transacciones: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      minimumFractionDigits: 0
    }).format(amount || 0);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('es-CL', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handlePhotoClick = (transaction) => {
    setSelectedTransaction(transaction);
    setShowPhotoModal(true);
  };

  const handleClosePhotoModal = () => {
    setShowPhotoModal(false);
    setSelectedTransaction(null);
  };

  const handleDetailClick = async (transaction) => {
    setDetailTransaction(transaction);
    setShowDetailModal(true);
    setLoadingRoutes(true);
    setDetailRoutes([]);

    // Fetch route details for all routeIds in the transaction
    if (transaction.routeIds && transaction.routeIds.length > 0) {
      try {
        const routePromises = transaction.routeIds.map(routeId => {
          const routeIdStr = typeof routeId === 'string' ? routeId : routeId.toString();
          return axios.get(`/api/routes/${routeIdStr}`);
        });
        const routeResponses = await Promise.all(routePromises);
        const routes = routeResponses.map(res => res.data);
        setDetailRoutes(routes);
      } catch (error) {
        console.error('Error fetching route details:', error);
        alert('Error al cargar detalles de rutas: ' + (error.response?.data?.message || error.message));
      } finally {
        setLoadingRoutes(false);
      }
    } else {
      setLoadingRoutes(false);
    }
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setDetailTransaction(null);
    setDetailRoutes([]);
  };

  if (loading) {
    return <div className="loading">Cargando transacciones...</div>;
  }

  return (
    <div className="container">
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '30px', 
        flexWrap: 'wrap', 
        gap: '15px',
        paddingBottom: '15px',
        borderBottom: '2px solid #e5e7eb'
      }}>
        <div>
          <h2 style={{ margin: 0, color: '#1e40af', fontSize: '28px', fontWeight: '600' }}>
            📊 Transacciones
          </h2>
          <p style={{ margin: '5px 0 0 0', color: '#6b7280', fontSize: '14px' }}>
            Historial completo de todos los pagos realizados
          </p>
        </div>
        <button 
          className="btn btn-secondary" 
          onClick={fetchTransactions} 
          style={{ 
            minWidth: '120px',
            padding: '10px 20px',
            fontSize: '14px',
            fontWeight: '500',
            borderRadius: '6px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            transition: 'all 0.2s'
          }}
          onMouseEnter={(e) => e.target.style.transform = 'translateY(-1px)'}
          onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
        >
          🔄 Actualizar
        </button>
      </div>

      {transactions.length === 0 ? (
        <div className="card" style={{
          textAlign: 'center',
          padding: '60px 20px',
          backgroundColor: '#f9fafb',
          border: '2px dashed #d1d5db',
          borderRadius: '12px'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '20px' }}>📋</div>
          <h3 style={{ color: '#374151', marginBottom: '10px' }}>No hay transacciones registradas</h3>
          <p style={{ color: '#6b7280', margin: 0 }}>
            Las transacciones aparecerán aquí una vez que se realicen los pagos.
          </p>
        </div>
      ) : (
        <div className="card" style={{
          borderRadius: '12px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          overflow: 'hidden',
          border: '1px solid #e5e7eb'
        }}>
          <div className="table-responsive">
            <table className="data-table" style={{
              width: '100%',
              borderCollapse: 'separate',
              borderSpacing: 0
            }}>
              <thead>
                <tr style={{ backgroundColor: '#f3f4f6' }}>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'left', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Fecha de Pago</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'left', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Empresa</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'center', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Aprobados</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'center', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Rechazados</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'center', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Viajes</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'right', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Monto</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'right', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Descuento</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'right', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Total</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'center', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>IVA</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'right', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>A Pagar</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'left', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Pagado Por</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'center', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Foto</th>
                  <th style={{ 
                    padding: '16px', 
                    textAlign: 'center', 
                    fontWeight: '600',
                    color: '#374151',
                    borderBottom: '2px solid #e5e7eb',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}>Detalle</th>
                </tr>
              </thead>
              <tbody>
                {transactions.map((transaction, index) => (
                  <tr 
                    key={transaction._id}
                    style={{
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb',
                      transition: 'background-color 0.2s',
                      borderBottom: '1px solid #e5e7eb'
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#f9fafb'}
                  >
                    <td data-label="Fecha de Pago" style={{ padding: '16px', color: '#374151', fontSize: '13px' }}>
                      {formatDate(transaction.paidAt)}
                    </td>
                    <td data-label="Empresa" style={{ padding: '16px' }}>
                      <strong style={{ color: '#1e40af', fontSize: '14px' }}>
                        {transaction.userId?.companyName || transaction.companyName || transaction.userId?.name || 'N/A'}
                      </strong>
                    </td>
                    <td data-label="Número de Aprobados" style={{ padding: '16px', textAlign: 'center' }}>
                      <span style={{ 
                        color: '#10b981', 
                        fontWeight: 'bold',
                        fontSize: '15px',
                        backgroundColor: '#d1fae5',
                        padding: '4px 10px',
                        borderRadius: '12px',
                        display: 'inline-block'
                      }}>
                        {transaction.numberOfApproved || 0}
                      </span>
                    </td>
                    <td data-label="Número de Rechazados" style={{ padding: '16px', textAlign: 'center' }}>
                      <span style={{ 
                        color: '#ef4444', 
                        fontWeight: 'bold',
                        fontSize: '15px',
                        backgroundColor: '#fee2e2',
                        padding: '4px 10px',
                        borderRadius: '12px',
                        display: 'inline-block'
                      }}>
                        {transaction.numberOfDeclined || 0}
                      </span>
                    </td>
                    <td data-label="Número de Viajes" style={{ padding: '16px', textAlign: 'center' }}>
                      <strong style={{ color: '#1e40af', fontSize: '15px' }}>
                        {transaction.numberOfTrips || 0}
                      </strong>
                    </td>
                    <td data-label="Monto" style={{ padding: '16px', textAlign: 'right', color: '#374151', fontWeight: '500' }}>
                      {formatCurrency(transaction.amount || 0)}
                    </td>
                    <td data-label="Descuento" style={{ padding: '16px', textAlign: 'right', color: '#6b7280', fontWeight: '500' }}>
                      {formatCurrency(transaction.discount || 0)}
                    </td>
                    <td data-label="Total" style={{ padding: '16px', textAlign: 'right' }}>
                      <strong style={{ color: '#374151', fontSize: '15px' }}>
                        {formatCurrency(transaction.total || 0)}
                      </strong>
                    </td>
                    <td data-label="IVA" style={{ padding: '16px', textAlign: 'center', color: '#6b7280', fontWeight: '500' }}>
                      {transaction.vat ? transaction.vat.toFixed(2) : '0.00'}
                    </td>
                    <td data-label="A Pagar" style={{ padding: '16px', textAlign: 'right' }}>
                      <strong style={{ 
                        color: '#10b981', 
                        fontSize: '16px',
                        fontWeight: '600'
                      }}>
                        {formatCurrency(transaction.toPay || 0)}
                      </strong>
                    </td>
                    <td data-label="Pagado Por" style={{ padding: '16px', color: '#6b7280', fontSize: '14px' }}>
                      {transaction.paidBy?.name || 'N/A'}
                    </td>
                    <td data-label="Foto" style={{ padding: '16px', textAlign: 'center' }}>
                      {transaction.paymentPhoto && transaction.paymentPhoto.path ? (
                        <button
                          className="btn btn-primary"
                          onClick={() => handlePhotoClick(transaction)}
                          style={{ 
                            padding: '6px 14px', 
                            fontSize: '12px',
                            borderRadius: '6px',
                            fontWeight: '500',
                            transition: 'all 0.2s',
                            border: 'none',
                            cursor: 'pointer'
                          }}
                          onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                          }}
                          onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = 'none';
                          }}
                        >
                          📷 Ver Foto
                        </button>
                      ) : (
                        <span style={{ color: '#9ca3af', fontSize: '13px' }}>-</span>
                      )}
                    </td>
                    <td data-label="Detalle" style={{ padding: '16px', textAlign: 'center' }}>
                      <button
                        className="btn btn-secondary"
                        onClick={() => handleDetailClick(transaction)}
                        style={{ 
                          padding: '6px 14px', 
                          fontSize: '12px',
                          borderRadius: '6px',
                          fontWeight: '500',
                          transition: 'all 0.2s',
                          border: 'none',
                          cursor: 'pointer'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-1px)';
                          e.target.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = 'none';
                        }}
                      >
                        📋 Detalle
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Photo Modal */}
      {showPhotoModal && selectedTransaction && selectedTransaction.paymentPhoto && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '30px',
            maxWidth: '90%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            position: 'relative',
            border: '1px solid #e5e7eb'
          }}>
            <button
              onClick={handleClosePhotoModal}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '36px',
                height: '36px',
                cursor: 'pointer',
                fontSize: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#dc2626';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#ef4444';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>
            <h3 style={{ 
              marginBottom: '24px', 
              color: '#1e40af',
              fontSize: '24px',
              fontWeight: '600',
              paddingRight: '40px'
            }}>
              📷 Foto del Pago - {selectedTransaction.userId?.companyName || selectedTransaction.companyName || 'N/A'}
            </h3>
            {selectedTransaction.paymentPhoto.path && (
              <img
                src={selectedTransaction.paymentPhoto.path}
                alt="Foto del pago"
                style={{
                  maxWidth: '100%',
                  height: 'auto',
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
                }}
                onError={(e) => {
                  console.error('Error loading payment photo:', selectedTransaction.paymentPhoto.path);
                  const errorMsg = document.createElement('p');
                  errorMsg.style.color = '#ef4444';
                  errorMsg.textContent = 'Error al cargar la imagen. Verifique que el servidor esté ejecutándose.';
                  e.target.parentElement.appendChild(errorMsg);
                  e.target.style.display = 'none';
                }}
              />
            )}
            {selectedTransaction.paidAt && (
              <p style={{ marginTop: '15px', color: '#666', fontSize: '14px' }}>
                Pagado el: {formatDate(selectedTransaction.paidAt)}
              </p>
            )}
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {showDetailModal && detailTransaction && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          backdropFilter: 'blur(4px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1000,
          padding: '20px'
        }}>
          <div style={{
            backgroundColor: 'white',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '90%',
            maxHeight: '90vh',
            overflow: 'auto',
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
            position: 'relative',
            width: '100%',
            maxWidth: '1000px',
            border: '1px solid #e5e7eb'
          }}>
            <button
              onClick={handleCloseDetailModal}
              style={{
                position: 'absolute',
                top: '15px',
                right: '15px',
                background: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '36px',
                height: '36px',
                cursor: 'pointer',
                fontSize: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#dc2626';
                e.target.style.transform = 'scale(1.1)';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = '#ef4444';
                e.target.style.transform = 'scale(1)';
              }}
            >
              ×
            </button>
            
            <h2 style={{ 
              marginBottom: '30px', 
              color: '#1e40af',
              fontSize: '28px',
              fontWeight: '600',
              paddingRight: '40px'
            }}>
              📋 Detalles de la Transacción
            </h2>

            {/* Transaction Summary */}
            <div style={{ 
              backgroundColor: '#ffffff', 
              padding: '28px', 
              borderRadius: '16px', 
              marginBottom: '32px',
              border: '2px solid #e5e7eb',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
              background: 'linear-gradient(135deg, #ffffff 0%, #f9fafb 100%)'
            }}>
              <h4 style={{ 
                marginBottom: '20px', 
                color: '#1e40af',
                fontSize: '18px',
                fontWeight: '600',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <span style={{ fontSize: '20px' }}>📊</span> Resumen de la Transacción
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '24px' }}>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Empresa</strong>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                    {detailTransaction.userId?.companyName || detailTransaction.companyName || detailTransaction.userId?.name || 'N/A'}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Fecha de Pago</strong>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                    {formatDate(detailTransaction.paidAt)}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Pagado Por</strong>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                    {detailTransaction.paidBy?.name || 'N/A'}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#eff6ff',
                  borderRadius: '10px',
                  border: '2px solid #3b82f6',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#3b82f6', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Número de Viajes</strong>
                  <p style={{ margin: 0, fontSize: '20px', fontWeight: '700', color: '#1e40af' }}>
                    {detailTransaction.numberOfTrips || 0}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#d1fae5',
                  borderRadius: '10px',
                  border: '2px solid #10b981',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#059669', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Aprobados</strong>
                  <p style={{ margin: 0, fontSize: '20px', color: '#10b981', fontWeight: '700' }}>
                    {detailTransaction.numberOfApproved || 0}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#fee2e2',
                  borderRadius: '10px',
                  border: '2px solid #ef4444',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#dc2626', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Rechazados</strong>
                  <p style={{ margin: 0, fontSize: '20px', color: '#ef4444', fontWeight: '700' }}>
                    {detailTransaction.numberOfDeclined || 0}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Monto</strong>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                    {formatCurrency(detailTransaction.amount || 0)}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Descuento</strong>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#6b7280' }}>
                    {formatCurrency(detailTransaction.discount || 0)}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>Total</strong>
                  <p style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#1f2937' }}>
                    {formatCurrency(detailTransaction.total || 0)}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#f9fafb',
                  borderRadius: '10px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#6b7280', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>IVA</strong>
                  <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#1f2937' }}>
                    {detailTransaction.vat ? detailTransaction.vat.toFixed(2) : '0.00'}
                  </p>
                </div>
                <div style={{
                  padding: '16px',
                  backgroundColor: '#d1fae5',
                  borderRadius: '10px',
                  border: '2px solid #10b981',
                  transition: 'all 0.2s'
                }}>
                  <strong style={{ color: '#059669', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', display: 'block', marginBottom: '8px' }}>A Pagar</strong>
                  <p style={{ margin: 0, fontSize: '22px', color: '#10b981', fontWeight: '700' }}>
                    {formatCurrency(detailTransaction.toPay || 0)}
                  </p>
                </div>
              </div>
            </div>

            {/* Routes List */}
            <div>
              <h3 style={{ 
                marginBottom: '20px', 
                color: '#1e40af',
                fontSize: '22px',
                fontWeight: '600',
                paddingBottom: '16px',
                borderBottom: '3px solid #3b82f6',
                display: 'flex',
                alignItems: 'center',
                gap: '10px'
              }}>
                <span style={{ fontSize: '24px' }}>🚛</span> Rutas Incluidas 
                <span style={{ 
                  backgroundColor: '#3b82f6', 
                  color: 'white', 
                  padding: '4px 12px', 
                  borderRadius: '12px', 
                  fontSize: '14px',
                  fontWeight: '600'
                }}>
                  {detailTransaction.routeIds?.length || 0}
                </span>
              </h3>
              
              {loadingRoutes ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <p>Cargando detalles de rutas...</p>
                </div>
              ) : detailRoutes.length === 0 ? (
                <div style={{ 
                  backgroundColor: '#fef3c7', 
                  padding: '15px', 
                  borderRadius: '8px',
                  border: '1px solid #fbbf24'
                }}>
                  <p style={{ margin: 0, color: '#92400e' }}>
                    No se encontraron rutas para esta transacción.
                  </p>
                </div>
              ) : (
                <div className="table-responsive" style={{ 
                  borderRadius: '12px', 
                  overflow: 'hidden', 
                  border: '2px solid #e5e7eb',
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                }}>
                  <table className="data-table" style={{ marginTop: '0', width: '100%', borderCollapse: 'separate', borderSpacing: 0 }}>
                    <thead>
                      <tr style={{ backgroundColor: '#1e40af', color: 'white' }}>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Número de Ruta</th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Destino</th>
                        <th style={{ padding: '14px 16px', textAlign: 'center', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Estado</th>
                        <th style={{ padding: '14px 16px', textAlign: 'right', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Precio Transporte</th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Transporte</th>
                        <th style={{ padding: '14px 16px', textAlign: 'left', fontWeight: '600', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Fecha de Creación</th>
                      </tr>
                    </thead>
                    <tbody>
                      {detailRoutes.map((route, index) => (
                        <tr 
                          key={route._id}
                          style={{
                            backgroundColor: index % 2 === 0 ? '#ffffff' : '#f9fafb',
                            borderBottom: '1px solid #e5e7eb',
                            transition: 'background-color 0.2s'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#eff6ff'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#f9fafb'}
                        >
                          <td data-label="Número de Ruta" style={{ padding: '16px', fontWeight: '600' }}>
                            <span style={{ 
                              color: '#1e40af', 
                              fontSize: '14px',
                              backgroundColor: '#eff6ff',
                              padding: '6px 12px',
                              borderRadius: '6px',
                              display: 'inline-block'
                            }}>
                              {route.routeNumber}
                            </span>
                          </td>
                          <td data-label="Destino" style={{ padding: '16px', color: '#374151', fontSize: '14px' }}>{route.endPoint || 'N/A'}</td>
                          <td data-label="Estado" style={{ padding: '16px', textAlign: 'center' }}>
                            <span className={`badge badge-${route.status === 'completed' ? 'completed' : route.status === 'rejected' ? 'rejected' : 'pending'}`} style={{ 
                              textTransform: 'none',
                              padding: '6px 14px',
                              borderRadius: '8px',
                              fontSize: '12px',
                              fontWeight: '600',
                              display: 'inline-block'
                            }}>
                              {route.status === 'completed' ? 'Completada' : route.status === 'rejected' ? 'Rechazada' : route.status}
                            </span>
                          </td>
                          <td data-label="Precio Transporte" style={{ padding: '16px', textAlign: 'right', color: '#374151', fontWeight: '600', fontSize: '14px' }}>
                            {formatCurrency(route.price || 0)}
                          </td>
                          <td data-label="Transporte" style={{ padding: '16px', color: '#374151', fontSize: '14px' }}>
                            {route.assignedTo?.companyName || route.assignedTo?.name || 'N/A'}
                          </td>
                          <td data-label="Fecha de Creación" style={{ padding: '16px', color: '#6b7280', fontSize: '13px' }}>
                            {formatDate(route.createdAt)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Payment Photo */}
            {detailTransaction.paymentPhoto && detailTransaction.paymentPhoto.path && (
              <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '2px solid #e5e7eb' }}>
                <h3 style={{ marginBottom: '15px', color: '#1e40af' }}>Foto del Pago</h3>
                <div style={{ textAlign: 'center' }}>
                  <img
                    src={detailTransaction.paymentPhoto.path}
                    alt="Foto del pago"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '400px',
                      height: 'auto',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setShowDetailModal(false);
                      handlePhotoClick(detailTransaction);
                    }}
                    onError={(e) => {
                      console.error('Error loading payment photo:', detailTransaction.paymentPhoto.path);
                      const errorMsg = document.createElement('p');
                      errorMsg.style.color = '#ef4444';
                      errorMsg.textContent = 'Error al cargar la imagen.';
                      e.target.parentElement.appendChild(errorMsg);
                      e.target.style.display = 'none';
                    }}
                  />
                  <p style={{ marginTop: '10px', color: '#666', fontSize: '14px', fontStyle: 'italic' }}>
                    Click en la imagen para ver en tamaño completo
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminTransactions;
